export const blackfireProjectVariable = projectVariables => {
  return projectVariables?.some(variable =>
    variable.name.includes("BLACKFIRE_SERVER")
  );
};

export const mainOnlyEnvironment = blackfireEnviromentVariables => {
  return (
    blackfireEnviromentVariables?.length === 1 &&
    Object.keys(blackfireEnviromentVariables[0])[0] === "main"
  );
};

export const blackfireEnvironmentVariablesFilter = multipleEnvironments =>
  multipleEnvironments?.filter(variable =>
    (Object.values(variable) as any)[0]?.some(value => {
      return value?.name.includes("BLACKFIRE_SERVER");
    })
  );

export const showViewAllEnvironments = (
  blackfireEnviromentVariables,
  projectVariables,
  minimumEnvironmentsToShowButton
) => {
  return (
    blackfireEnviromentVariables?.length + !!projectVariables >
    minimumEnvironmentsToShowButton
  );
};
